import { HorizontalBar } from 'vue-chartjs';
import { ChartDataLabels } from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';

Chart.defaults.bar.defaultFontSize = 8;

export default {
  extends: HorizontalBar,
  props: ['data', 'options'],
  plugins: ['chart-data-labels'],
  components: { ChartDataLabels },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.data, {
      legend: { display: false },
      title: {
        display: true,
        padding: 0,
        //text: 'Top 10 holdings for Existing Portfolio'
      },
      tooltips: false,
      show_as_html: true,
      scales: {
        xAxes: [{
          gridLines: {
            display: false,
          },
          ticks: {
            fontSize: '8',
            fontColor: '#666666',
            fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
            fontStyle: 'normal',
          },
          pointLabels :{
            fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
            fontStyle: 'normal',
         }
        }],
        yAxes: [{
          gridLines: {
            display: false,
          },
          ticks: {
            fontSize: '8',
            fontColor: '#666666',
            fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
            fontStyle: 'normal',
          },
          pointLabels :{
            fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
            fontStyle: 'normal',
         }
        }],
      },
      plugins: {
        datalabels: {
          color: '#000000',
          align: 0,
          anchor: 'end',
          font: {
            size: 8,
          },
          formatter(value) {
            if (value > 0) {
              return `${value}%`;
            }
            return '';
          },
          offset:0,
          padding: {
            left: 0,
          },
        },
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/Charts/BarChart.js